module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("   Contents   ")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_3.jpg"
    }
  })])])]), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_The_Pleasures_of_Tea"
    }
  }, [_vm._v("The Pleasures of Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Growing_Tea"
    }
  }, [_vm._v("Growing Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_The_History_of_Tea"
    }
  }, [_vm._v("The History of Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Styles_and_Customs_Today",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Styles and Customs Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Choosing_and_Using_Tea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing and Using Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_A_Perfect_Cup_of_Tea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Perfect Cup of Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/13_Chapter01_Head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tea Served Hot, Cold and Frozen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot drinks with alcohol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold drinks with alcohol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot non-alcoholic drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold non-alcoholic drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/16_Chapter02_Head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good baking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freezing teatime food")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern yeast cookery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To follow the recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime for slimmers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regency teatime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victorian teatime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime in England")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime in Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime in Wales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime in Ireland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nursery Teas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/19_Chapter03_Head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teatime around the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter03#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Zealand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South Africa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/22_Chapter04_Head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb521b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0